import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export function Breadcrumb({ items }) {
    return (
        <nav aria-label="Breadcrumb" className="text-sm text-slate-500">
            <ol className="flex items-center gap-1.5 flex-wrap">
                {items.map((it, idx) => {
                    const last = idx === items.length - 1;
                    return (
                        <li key={idx} className="flex items-center gap-1.5">
                            {idx > 0 ? (
                                <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
                            ) : null}
                            {last || !it.to ? (
                                <span className="text-slate-700">{it.label}</span>
                            ) : (
                                <Link to={it.to} className="hover:text-slate-900">
                                    {it.label}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
